(function () {
  if (window.ProductFloatingPurchaseBarLoaded) return;
  window.ProductFloatingPurchaseBarLoaded = true;

  function formatMoney(cents, format) {
    if (window.theme && window.theme.utils && typeof window.theme.utils.formatMoney === 'function') {
      return window.theme.utils.formatMoney(cents, format);
    }
    if (typeof window.formatMoney === 'function') return window.formatMoney(cents, format);
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function sourceVariantInput(bar) {
    var selectors = [
      '[data-iph-root] [data-iph-variant-id]',
      '[data-l5p-product-root] [data-l5p-variant-input]',
      '.bp--product form[data-type="add-to-cart-form"] [name="id"]',
      '.l5p--product form[data-type="add-to-cart-form"] [name="id"]',
      'form[data-type="add-to-cart-form"] [name="id"]'
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var candidate = document.querySelector(selectors[i]);
      if (candidate && !candidate.closest('[data-product-floating-purchase-bar]')) return candidate;
    }
    return null;
  }

  function initialize(bar) {
    if (!bar || bar.dataset.initialized === 'true') return;
    bar.dataset.initialized = 'true';

    var variantsNode = bar.querySelector('[data-floating-variants]');
    var variants = [];
    try {
      variants = JSON.parse(variantsNode ? variantsNode.textContent : '[]');
    } catch (error) {
      console.error('Unable to read floating purchase variants.', error);
    }

    var variantInput = bar.querySelector('[data-floating-variant-id]');
    var price = bar.querySelector('[data-floating-price]');
    var variantLabel = bar.querySelector('[data-floating-variant]');
    var submit = bar.querySelector('[data-floating-submit]');
    var submitLabel = bar.querySelector('[data-floating-submit-label]');
    var moneyFormat = bar.dataset.moneyFormat || '${{amount}}';
    var buttonLabel = submit ? (submit.dataset.buttonLabel || 'Add to Cart') : 'Add to Cart';
    var soldOutLabel = submit ? (submit.dataset.soldOutLabel || 'Sold Out') : 'Sold Out';
    var lastVariantId = '';

    bar.hidden = false;

    function findVariant(id) {
      return variants.find(function (variant) { return String(variant.id) === String(id); });
    }

    function updateVariant(variant, displayTitle) {
      if (!variant) return;
      lastVariantId = String(variant.id);
      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price, moneyFormat);
      bar.toggleAttribute('data-variant-display-label', Boolean(displayTitle));
      if (variantLabel) {
        variantLabel.textContent = displayTitle || variant.title || '';
        variantLabel.hidden = !variant.title || variant.title === 'Default Title';
      }
      if (submit) {
        var available = Boolean(variant.available);
        submit.disabled = !available;
        submit.setAttribute('aria-disabled', available ? 'false' : 'true');
      }
      if (submitLabel) submitLabel.textContent = variant.available ? buttonLabel : soldOutLabel;
    }

    function syncVariant() {
      var input = sourceVariantInput(bar);
      var variant = findVariant(input && input.value) || findVariant(variantInput && variantInput.value);
      var displayTitle = input && input.dataset.variantDisplayTitle;
      if (variant && (String(variant.id) !== lastVariantId || (variantLabel && variantLabel.textContent !== (displayTitle || variant.title || '')))) {
        updateVariant(variant, displayTitle);
      }
    }

    function observedPurchaseRegion() {
      return Array.prototype.slice.call(document.querySelectorAll(bar.dataset.observeSelectors || '[data-iph-root]'));
    }

    function updateVisibility() {
      var targets = observedPurchaseRegion();
      if (!targets.length) return;
      var shouldShow = targets.some(function (target) {
        return target.getBoundingClientRect().bottom <= 0;
      });
      bar.classList.toggle('is-visible', shouldShow);
    }

    document.addEventListener('change', function (event) {
      if (event.target && event.target.name === 'id' && !event.target.closest('[data-product-floating-purchase-bar]')) {
        syncVariant();
      }
    });

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    window.setInterval(syncVariant, 250);
    syncVariant();
    updateVisibility();
  }

  function initializeAll(scope) {
    Array.prototype.slice.call((scope || document).querySelectorAll('[data-product-floating-purchase-bar]')).forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
